document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.p-access-car__route-map__button');
  const maps = document.querySelectorAll('.p-access-car__route-map__item');
  const headerHeight = document.querySelector('header').offsetHeight; // ヘッダーの高さを取得

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');

      // マップの切り替え
      maps.forEach(map => {
        map.classList.remove('is-show');
      });

      const targetMap = document.getElementById(targetId);
      if (targetMap) {
        targetMap.classList.add('is-show');

        // アンカー遷移（ヘッダー分を考慮してスムーズスクロール）
        const targetPosition = targetMap.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
